import type { Dispatch } from "react";
import type React from "react";
import { type Action, ActionType } from "../@types";

export const setMbpReferrerUri = (
  dispatch: Dispatch<Action>,
  uri?: string
): void => {
  dispatch({
    type: ActionType.UPDATE_MBP_REFERRER_URI,
    payload: uri,
  });
};

export const clearMbpReferrerUri = (dispatch: Dispatch<Action>) =>
  setMbpReferrerUri(dispatch, "");

export const clearMbpReferrerUriAndRedirect = ({
  dispatch,
  mbpReferrerUri,
  e,
}: {
  dispatch: Dispatch<Action>;
  mbpReferrerUri: string;
  e: React.MouseEvent<HTMLAnchorElement, MouseEvent>;
}): void => {
  e.preventDefault();
  clearMbpReferrerUri(dispatch);
  window?.location?.assign(mbpReferrerUri);
};
